// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// Development Envronment
export const environment = {
  production: false,
  stripeKey: 'pk_test_axi5SnPRgai8z56Yc8QM3AKl',
  MapGoogleAPIKey: 'AIzaSyDXP7eW--Hq-7TLA_t4evfg2-_PvgxO8fE',
  markerGarLocationPng: 'http://maps.google.com/mapfiles/kml/pal3/icon48.png',
  adminemail: 'KEYINFO@EMAIL.COM',
  encryptkey: 'Hannah88',
  eventplannercost: 49.95   // AUD Dollars
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
